.root {
  display: block;
  svg {
    display: block;
    width: 100%;
    height: auto;
  }
}
